import styled from "styled-components";

/**
 * 写真ダイアログのスタイルコンポーネント
 * 元のPHPデザイン（Fileup.ctp）を参考に作成
 */
const FileupDialogStyles = {
  FlexBetween: styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 0;
  `,

  FlexRow: styled.div`
    display: flex;
    flex-direction: row;
    gap: 0;
  `,
  // メインコンテナ
  FileContainer: styled.div`
    /* width: 980px; */
    height: auto;            
    max-height: none;        
    overflow: visible;       
    background-color: white;
    border: 5px solid #ccc;
    box-sizing: border-box;
  `,

  // タイトル
  FileTitle: styled.h2`
    margin: 0 0 20px 0;
    font-size: 24px;
    color: #333;
    font-weight: bold;
  `,

  // 注文詳細セクション
  OrderDetail: styled.div`
    background: #f9f9f9;
    border: 1px solid #ddd;
    padding: 15px;
    margin-bottom: 20px;
    border-radius: 5px;
  `,

  OrderDetailList: styled.dl`
    display: flex;
    flex-wrap: wrap;
    margin: 0;
    padding: 0;
  `,

  OrderDetailItem: styled.div`
    display: flex;
    width: 50%;
    margin-bottom: 8px;
  `,

  OrderDetailLabel: styled.dt`
    font-weight: bold;
    color: #333;
    margin-right: 10px;
    min-width: 80px;
  `,

  OrderDetailValue: styled.dd`
    margin: 0;
    color: #666;
  `,

  // 一括アップロードセクション
  BulkUploadSection: styled.div`
    background: #f0f8ff;
    border: 1px solid #b0d4f1;
    padding: 15px;
    margin-bottom: 20px;
    border-radius: 5px;
  `,

  BulkUploadTitle: styled.h3`
    margin: 0 0 10px 0;
    font-size: 16px;
    color: #333;
  `,

  BulkUploadButton: styled.label`
    display: inline-block;
    background: #ddd;
    color: #333;
    height: 28px;
    border: 1px solid #999;
    border-radius: 5px;
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    padding: 0 10px;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
      background: #ccc;
    }

    input[type="file"] {
      display: none;
    }
  `,

  // 写真グリッドテーブル
  FileGridTable: styled.table`
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
  `,

  FileGridRow: styled.tr`
    display: flex;
    flex-wrap: wrap;
  `,

  FileGridCell: styled.td`
    width: 195px;
    padding: 5px;
    box-sizing: border-box;
  `,

  // 写真アイテム
  FileItem: styled.div`
    width: 180px;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 5px;
    background: white;
  `,

  FileDropArea: styled.div`
    height: 144px;
    border: 2px dashed #ccc;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fafafa;
    cursor: pointer;
    transition: all 0.2s;
    position: relative;

    &:hover {
      border-color: #999;
      background: #f0f0f0;
    }

    &.drag-over {
      border-color: #007bff;
      background: #e3f2fd;
    }
  `,

  FileImage: styled.img`
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    border-radius: 3px;
  `,

  FileLink: styled.a`
    display: block;
    width: 100%;
    height: 100%;
    text-decoration: none;
  `,

  // アップロードボタンエリア
  UploadButtonArea: styled.div`
    margin-top: 10px;
    text-align: center;
  `,

  UploadButton: styled.label`
    display: inline-block;
    background: #ddd;
    color: #333;
    height: 28px;
    border: 1px solid #999;
    border-radius: 5px;
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    padding: 0 10px;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
      background: #ccc;
    }

    input[type="file"] {
      display: none;
    }
  `,

  // 削除ボタン
  DeleteButton: styled.button`
    background: #f44336;
    color: white;
    border: none;
    border-radius: 3px;
    padding: 5px 10px;
    font-size: 12px;
    cursor: pointer;
    margin-top: 5px;
    transition: background-color 0.2s;

    &:hover {
      background: #d32f2f;
    }

    &:disabled {
      background: #ccc;
      cursor: not-allowed;
    }
  `,

  // 登録ボタンセクション
  RegisterSection: styled.div`
    text-align: center;
    margin-top: 20px;
    padding: 20px;
    background: #f9f9f9;
    border-radius: 5px;
  `,

  RegisterButton: styled.button`
    background: #4caf50;
    color: white;
    border: none;
    border-radius: 5px;
    padding: 12px 30px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
      background: #45a049;
    }

    &:disabled {
      background: #ccc;
      cursor: not-allowed;
    }
  `,

  // エラーメッセージ
  ErrorMessage: styled.div`
    background: #ffebee;
    color: #c62828;
    border: 1px solid #ffcdd2;
    border-radius: 4px;
    padding: 10px;
    margin: 10px 0;
    font-size: 14px;
  `,

  // 成功メッセージ
  SuccessMessage: styled.div`
    background: #e8f5e8;
    color: #2e7d32;
    border: 1px solid #c8e6c9;
    border-radius: 4px;
    padding: 10px;
    margin: 10px 0;
    font-size: 14px;
  `,

  // ローディング表示
  LoadingOverlay: styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    color: #666;
  `,

  // プログレスバー
  ProgressBar: styled.div`
    width: 100%;
    height: 4px;
    background: #e0e0e0;
    border-radius: 2px;
    overflow: hidden;
    margin-top: 5px;
  `,

  ProgressFill: styled.div`
    height: 100%;
    background: #4caf50;
    transition: width 0.3s ease;
    width: ${(props) => props.progress || 0}%;
  `,

  // ファイル情報表示
  FileInfo: styled.div`
    font-size: 12px;
    color: #666;
    margin-top: 5px;
    text-align: center;
  `,

  // ドラッグ&ドロップのヒント
  DragHint: styled.div`
    font-size: 12px;
    color: #999;
    text-align: center;
    margin-top: 5px;
  `,

  // 閉じるボタン
  CloseButton: styled.button`
    position: absolute;
    top: 10px;
    right: 10px;
    background: none;
    border: none;
    cursor: pointer;
    padding: 5px;
    border-radius: 3px;
    transition: background-color 0.2s;

    &:hover {
      background: #f0f0f0;
    }

    img {
      width: 20px;
      height: 20px;
    }
  `,

  // レスポンシブ対応
  ResponsiveContainer: styled.div`
    @media (max-width: 768px) {
      width: 100%;
      height: auto;
      max-height: 80vh;
      padding: 15px;
    }
  `,

  // 写真グリッド行
  FileGridRow: styled.tr`
    display: flex;
    flex-wrap: wrap;
  `,

  // 写真セル
  FileCell: styled.td`
    width: 20%;
    background: #fff;
    border: 1px solid #333;
    padding: 8px 2px;
    box-sizing: border-box;
  `,

  // パーツミニ
  PartsMini: styled.div`
    width: 100%;
    /* border: 1px solid #ccc; */
    /*border-radius: 5px;*/
    padding: 5px;
    background: white;
  `,

  // 写真ドロップエリア
  FileDrop: styled.div`
    height: 144px;
    /*border: 2px dashed #ccc;*/
    /*border-radius: 5px;*/
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fafafa;
    cursor: pointer;
    transition: all 0.2s;
    position: relative;

    &:hover {
      border-color: #999;
      background: #f0f0f0;
    }

    &.drag-over {
      border-color: #007bff;
      background: #e3f2fd;
    }

    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
      border-radius: 3px;
    }
  `,

  // ミニ右ボックス
  MiniRightBox: styled.div`
    margin-top: 10px;
    text-align: center;
  `,

  // ファイルマスク2
  FileMask2: styled.div`
    display: inline-block;
    position: relative;
  `,

  // 隠しファイル
  HiddenFile: styled.input`
    display: none;
  `,

  // ファイルマスク2スパン
  FileMask2Span: styled.span`
    display: inline-block;
    background: #ddd;
    color: #333;
    height: 28px;
    border: 1px solid #999;
    border-radius: 5px;
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    padding: 0 10px;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
      background: #ccc;
    }
  `,

  // 隠しテキスト
  HiddenText: styled.input`
    display: none;
  `,

  // グレーボタン
  BtnGray: styled.button`
    background: #ddd;
    color: #333;
    height: 28px;
    border: 1px solid #999;
    border-radius: 5px;
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    padding: 0 10px;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
      background: #ccc;
    }

    &.disable-btn {
      background: #f5f5f5;
      color: #999;
      cursor: not-allowed;
    }
  `,

  // レッドボタン
  BtnRed: styled.button`
    background: #d60000;  
    color: #fff;          
    font-weight: bold;     
    height: 28px;
    border: 1px solid #990000;
    border-radius: 5px;
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    padding: 0 10px;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
      background: #b00000;
    }

    &.disable-btn {
      background: #f5c0c0;
      color: #fff;
      cursor: not-allowed;
      border-color: #e0a0a0;
    }
  `,

  // 詳細テーブル
  DetailTable: styled.table`
    width: 100%;
    border: 1px solid #999;
    margin-bottom: 5px;
    table-layout: fixed;

    caption {
      background: #999;
      color: #333;
      font-size: 16px;
      font-weight: bold;
      text-align: left;
      padding: 2px 5px;
    }

    th,
    td {
      background: #fff;
      font-size: 14px;
      padding: 5px;
      border-width: 1px 1px 1px 0;
      border-color: #999;
      border-style: solid;
      text-align: left;
      color: #333;
    }

    th {
      background: #e4e4e4;
      font-size: 14px;
      font-weight: bold;
      padding: 5px;
      border-width: 1px 0 1px 1px;
      border-color: #999;
      border-style: solid;
      text-align: right;
      color: #333;
      width: 7em;
    }
  `,

  DetailTableCustom: styled.table`
    width: 100%;
    border: 2px solid #ff8c00;        /* 全体オレンジ枠 */
    background: #fff9c4;              /* 背景黄色 */
    margin-bottom: 10px;
    border-collapse: collapse;

    td {
      padding: 6px 10px;
      background: #fff9c4;
      border: none;                   /* 内側の罫線なし */
    }

    .label {
      color: #000;                    /* ラベル黒 */
      font-weight: bold;
      margin-right: 4px;
    }

    .value {
      color: #0066ff;                 /* 値は青 */
      font-weight: bold;
      margin-right: 16px;             /* 次のラベルとの間隔 */
    }

    .space {
      display: inline-block;
      width: 20px;
    }
  `,

  // 通常テーブル
  NormalTable: styled.table`
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
    background: white;
    border: 1px solid #ddd;
    border-radius: 5px;

    td {
      padding: 8px 12px;
      border-bottom: 1px solid #eee;
    }
  `,

  // キャプション
  Caption: styled.caption`
    background: #3366ff;
    color: #FFF;
    font-size: 16px;
    font-weight: bold;
    text-align: left;
    padding: 2px 5px;
}
  `,

  // テキストノートテーブル
  TextNoteTable: styled.table`
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 20px;
    background: white;
    border: 1px solid #ddd;
    border-radius: 5px;

    caption {
      font-weight: bold;
      padding: 10px;
      background: #f5f5f5;
      border-bottom: 1px solid #ddd;
      text-align: left;
    }

    td {
      padding: 8px 12px;
      border-bottom: 1px solid #eee;
    }
  `,

  // 重要ボタン
  ImportantBtn: styled.input`
    background: #4caf50;
    color: white;
    border: none;
    border-radius: 5px;
    padding: 12px 30px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
      background: #45a049;
    }

    &:disabled {
      background: #ccc;
      cursor: not-allowed;
    }
  `,

  // ローディングスピナー
  LoadingSpinner: styled.div`
    width: 40px;
    height: 40px;
    border: 4px solid #f3f3f3;
    border-top: 4px solid #3498db;
    border-radius: 50%;
    animation: spin 1s linear infinite;

    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  `,
};

export default FileupDialogStyles;
